import Keycloak from "keycloak-js";


const keycloak = new Keycloak({
	url: "https://self.se.jku.at",
	realm: "general-auth",
	clientId: "angular",
});


const initKeycloak = (startAppFunction) => {
	keycloak.init({onLoad: 'check-sso', checkLoginIframe: false})
    .then((authenticated) => {startAppFunction(!authenticated)})
    .catch(console.error)
};


const doLogin = keycloak.login;
const doLogout = keycloak.logout;
const getToken = () => keycloak.token;
const isLoggedIn = () => !!keycloak.token;
const getUsername = () => keycloak.tokenParsed?.preferred_username;
const hasRole = (roles) => roles.some((role) => keycloak.hasRealmRole(role));
const updateToken = (successCallback) => keycloak.updateToken(5).then(successCallback).catch(doLogin);


const SSO = {
	initKeycloak,
  	doLogin,
  	doLogout,
  	isLoggedIn,
  	getToken,
  	updateToken,
  	getUsername,
  	hasRole,
};


export default SSO;

